import { css } from '@emotion/react';

export const sectionContainer = css`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const sectionHeader = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 6px;
    background: #002755;
    color: white;
    border-radius: 8px;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.5px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #003366;
    }
`;

export const headerContent = css`
    display: flex;
    align-items: center;
    margin-left: 8px;
    gap: 8px;
`;

export const iconButton = css`
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const sectionContent = css`
    padding: 4px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    overflow: hidden;
    transition: all 0.2s ease;
`;

export const collapsedContent = css`
    padding: 0;
    max-height: 0;
    opacity: 0;
`;

export const expandedContent = css`
    padding-left: 4px;
    padding-right: 4px;
    max-height: 1000px;
    opacity: 1;
`;
